import { useCookie } from "#app"
import { parseJwt, willExpireSoon, isExpired } from "../utils/auth"
export default defineNuxtRouteMiddleware((to, from) => {
	const token: string | undefined | null = useCookie("auth_token").value

	// Define public routes
	const publicRoutes = ["/login", "/forgot", "/sign-up", "/create", "/verify/new"]

	const isPublicRoute =
		publicRoutes.includes(to.path) ||
		to.path.startsWith("/verify/") ||
		to.path.includes("/password")

	// Redirect to login if no token and not on public route
	if (!token && !isPublicRoute) {
		return navigateTo("/login")
	}
	if (token) {
		try {
			if (isExpired(token)) {
				useCookie("auth_token").value = null
				if (!isPublicRoute) {
					return navigateTo("/login")
				}
			}
			const payload = parseJwt(token)
			const expiresSoon = willExpireSoon(payload.exp)
			if (expiresSoon && import.meta.client) {
				window.dispatchEvent(new Event("token-expiring"))
			}
		} catch {
			useCookie("auth_token").value = null
			return navigateTo("/login")
		}
	}
})
